// TI-30XS-style math on exact fractions (floats only after a non-perfect root or fractional power).
const gcd = (a, b) => { a = Math.abs(a); b = Math.abs(b); while (b) [a, b] = [b, a % b]; return a || 1; };
export const R = (n, d = 1) => { if (d === 0) throw new Error("DIVIDE BY 0"); const s = d < 0 ? -1 : 1, g = gcd(n, d); return { n: (s * n) / g, d: (s * d) / g }; };
const isF = (x) => typeof x === "number";
const val = (x) => (isF(x) ? x : x.n / x.d);
const op = (a, b, f, g) => (isF(a) || isF(b) ? f(val(a), val(b)) : g(a, b));
const add = (a, b) => op(a, b, (x, y) => x + y, (x, y) => R(x.n * y.d + y.n * x.d, x.d * y.d));
const sub = (a, b) => add(a, isF(b) ? -b : R(-b.n, b.d));
const mul = (a, b) => op(a, b, (x, y) => x * y, (x, y) => R(x.n * y.n, x.d * y.d));
const div = (a, b) => { if (val(b) === 0) throw new Error("DIVIDE BY 0"); return op(a, b, (x, y) => x / y, (x, y) => R(x.n * y.d, x.d * y.n)); };
const pow = (a, b) => {
  if (!isF(b) && b.d === 1 && !isF(a) && Math.abs(b.n) <= 64) {
    const e = Math.abs(b.n); const p = R(a.n ** e, a.d ** e);
    return b.n < 0 ? div(R(1), p) : p;
  }
  return Math.pow(val(a), val(b));
};
const sqrt = (a) => {
  if (val(a) < 0) throw new Error("DOMAIN ERROR");
  if (!isF(a)) { const n = Math.round(Math.sqrt(a.n)), d = Math.round(Math.sqrt(a.d)); if (n * n === a.n && d * d === a.d) return R(n, d); }
  return Math.sqrt(val(a));
};

export function evaluate(tokens) {
  let i = 0;
  const peek = () => tokens[i];
  const fail = () => { throw new Error("SYNTAX ERROR"); };
  const number = () => {
    let s = "";
    while (/^[0-9.]$/.test(peek() || "")) s += tokens[i++];
    if (!s || s === "." || (s.match(/\./g) || []).length > 1) fail();
    const [w, f = ""] = s.split(".");
    return R(Number(w + f), 10 ** f.length);
  };
  const closeParen = () => { if (peek() === ")") i++; else if (peek() !== undefined) fail(); };
  const primary = () => {
    const t = peek();
    if (t === "(") { i++; const v = expr(); closeParen(); return v; }
    if (t === "√(") { i++; const v = expr(); closeParen(); return sqrt(v); }
    const n = number();
    if (peek() === "frac") { i++; const d = number(); return div(n, d); }
    return n;
  };
  const postfix = () => { let v = primary(); while (peek() === "²") { i++; v = pow(v, R(2)); } return v; };
  const power = () => { const b = postfix(); if (peek() === "^") { i++; return pow(b, unary()); } return b; };
  const unary = () => { if (peek() === "neg") { i++; const v = unary(); return isF(v) ? -v : R(-v.n, v.d); } return power(); };
  const term = () => { let v = unary(); while (peek() === "×" || peek() === "÷") { const o = tokens[i++]; v = o === "×" ? mul(v, unary()) : div(v, unary()); } return v; };
  const expr = () => { let v = term(); while (peek() === "+" || peek() === "−") { const o = tokens[i++]; v = o === "+" ? add(v, term()) : sub(v, term()); } return v; };
  if (!tokens.length) fail();
  const v = expr();
  if (i < tokens.length) fail();
  return v;
}

export const asDecimal = (v) => { const x = val(v); return String(Math.round(x * 1e10) / 1e10); };
export const asFraction = (v) => (isF(v) ? asDecimal(v) : v.d === 1 ? String(v.n) : `${v.n}/${v.d}`);
export const numeric = val;
export const SHOW = { neg: "⁻", frac: "⁄", "√(": "√(", "²": "²" };
